import React from 'react';
import { useTranslation } from 'react-i18next';
import './VideoMuxerDelayInput.scss';
import ToggleButton from '../../ProducerComponents/ProducerControlPanel/Widgets/ToggleButton';
import useProject from '../../../hooks/useProject';

const VideoMuxerDelayInput = () => {
  const { t } = useTranslation();
  const { updateEncoder, updateStream, project } = useProject();

  const onChange = (value: string | number | boolean) => {
    if (project.stream.sourceLanguageIsoCode === project.encoder.languageIsoCode) {
      updateStream({
        transcoderVideoMuxerDelay: value,
      });
    } else {
      updateEncoder(project.encoder, {
        transcoderVideoMuxerDelay: value,
      });
    }
  };

  return (
    <div className="video-muxer-delay-input">
      <div className="input-title">{t('producer.inputs.video-muxer-delay.title')}</div>
      <ToggleButton
        leftText={t('producer.common.on')}
        leftValue={true}
        leftButtonClassName={`video-muxer-delay-button ${
          project.encoder?.transcoderVideoMuxerDelay === true
            ? 'control-panel-button-selected-button'
            : null
        }`}
        leftContentClassName="video-muxer-delay-text"
        rightText={t('producer.common.off')}
        rightValue={false}
        rightButtonClassName={`video-muxer-delay-button ${
          project.encoder?.transcoderVideoMuxerDelay === false
            ? 'control-panel-button-selected-button'
            : null
        }`}
        rightContentClassName="video-muxer-delay-text"
        footerText={t('producer.inputs.video-muxer-delay.footer')}
        isReadOnly={false}
        onSelection={onChange}
        leftAccessibilityName={t('producer.common.on')}
        rightAccessibilityName={t('producer.common.off')}
      />
    </div>
  );
};

export default React.memo(VideoMuxerDelayInput);
